"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _revalidate = require("revalidate");

var validateLinkAccounts = (0, _revalidate.combineValidators)({
  password: (0, _revalidate.composeValidators)(_revalidate.isRequired, (0, _revalidate.hasLengthGreaterThan)(6 - 1))("Password")
});

exports.default = validateLinkAccounts;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/EpicMigration/linkAccountsFormValidation.js
// module id = 1261
// module chunks = 0